import { useI18n } from "../context/I18nContext";
import { Languages } from "lucide-react";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export default function LanguageSwitcher({ variant = "ghost" }) {
    const { lang, setLang, langs } = useI18n();
    const current = langs.find((l) => l.code === lang) || langs[0];
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    className={`inline-flex items-center gap-2 rounded-full px-3 py-2 text-sm font-bold transition-all ${
                        variant === "ghost" ? "hover:bg-slate-100 text-onego-navy" : "bg-onego-navy text-white"
                    }`}
                    data-testid="language-switcher"
                >
                    <Languages size={16} /> {current.label}
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" data-testid="lang-switcher-menu">
                {langs.map((l) => (
                    <DropdownMenuItem
                        key={l.code}
                        onClick={() => setLang(l.code)}
                        className={l.code === lang ? "font-bold bg-slate-50" : ""}
                        data-testid={`lang-option-${l.code}`}
                    >
                        {l.name}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
